"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const botones_1 = require("../../botones");
const index_1 = require("../../selector/index");
const helpers_1 = require("../simpleGrid/helpers");
function filter(item, data, string) {
    if (data.valores == null)
        return true;
    if (data.valores.length == 0)
        return true;
    return data.valores.indexOf(string) != -1;
}
function FiltroValorUnicoComponent(props) {
    const x = props.value || { valores: [] };
    const items = getItems(props.items || [], props.column);
    const titulo = props.titulo;
    const label = React.createElement("span", null,
        React.createElement(botones_1.Link, { iconClass: "fa fa-times", onClick: props.onQuitar }),
        " ",
        React.createElement("label", null, titulo));
    return (React.createElement("div", null,
        React.createElement(index_1.Select, { value: x.valores || [], onChange: x => props.onChange({ valores: x }), items: items, label: label, multi: true })));
}
/**Obtiene los valroes unicos de una columna */
function valoresUnicos(datos, column) {
    const valores = datos.map(fila => fila.cell[column].string);
    const set = new Set(valores);
    return Array.from(set).sort((a, b) => helpers_1.compare(a, b));
}
function getItems(datos, column) {
    return valoresUnicos(datos, column).map(x => ({ value: x, label: x }));
}
exports.filtro = {
    component: FiltroValorUnicoComponent,
    filter: (item, data, string) => filter(item, data, string)
};



//////////////////
// WEBPACK FOOTER
// ./~/kea-react/dist/grid2Base/filtros/valorUnico.js
// module id = 507
// module chunks = 0